import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background relative overflow-hidden">
      {/* Floating Ghost */}
      <div className="animate-float mb-8">
        <svg 
          className="w-32 h-32 md:w-48 md:h-48 ghost-glow" 
          viewBox="0 0 100 120" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Ghost body */}
          <path 
            d="M50 10C30 10 15 25 15 45V90C15 95 18 98 20 98C22 98 25 95 28 95C31 95 34 98 37 98C40 98 43 95 46 95C49 95 52 98 55 98C58 98 61 95 64 95C67 95 70 98 73 98C76 98 79 95 82 95C85 95 88 98 90 98C92 98 95 95 95 90V45C95 25 80 10 60 10H50Z" 
            fill="hsl(var(--foreground))"
            opacity="0.15"
          />
          {/* Eyes */}
          <circle cx="35" cy="50" r="5" fill="hsl(var(--foreground))" opacity="0.3"/>
          <circle cx="65" cy="50" r="5" fill="hsl(var(--foreground))" opacity="0.3"/>
        </svg>
      </div>

      {/* 404 Content */}
      <div className="text-center space-y-6 animate-fade-in z-10">
        <h1 className="text-6xl md:text-8xl font-bold gradient-text">
          {t('notFound.title')}
        </h1>
        <p className="text-xl md:text-2xl text-foreground/80 font-medium">
          {t('notFound.message')}
        </p>
        <Link 
          to="/" 
          className="inline-block mt-8 px-8 py-3 bg-primary/10 hover:bg-primary/20 text-primary border border-primary/30 rounded-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(var(--primary),0.3)]"
        >
          {t('notFound.returnHome')}
        </Link>
      </div>

      {/* Background Effect */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/20 rounded-full blur-[100px] animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-accent/20 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
    </div>
  );
};

export default NotFound;
